/**
 * Zelf Zorgen Samen Doen
 *
 * @author Robuust
 * @author Rutger Bakker <rutger@robuust.digital>
 */
import { Controller } from '@hotwired/stimulus';
import { gsap } from 'gsap';

/**
 * Parallax controller
 */
export default class extends Controller {
  static targets = ['image'];

  /**
   * GSAP context.
   */
  ctx = null;

  /**
   * GSA quickTo positions.
   */
  positions = [];

  /**
   * Initialize the controller.
   */
  initialize() {
    this.ctx = gsap.context(() => {});
  }

  /**
   * Connect the controller
   */
  connect() {
    this.centerX = window.innerWidth / 2;
    this.centerY = window.innerHeight / 2;
    this.imageTargets.forEach((image) => {
      this.ctx.add(() => {
        const x = gsap.quickTo(image, 'x', { duration: 0.4, ease: 'power3', force3D: true });
        const y = gsap.quickTo(image, 'y', { duration: 0.4, ease: 'power3', force3D: true });
        const pos = { x, y };

        this.positions.push(pos);
      });
    });
  }

  /**
   * Handle mouse/touch movement
   *
   * @param {Event} event
   */
  onMove(event) {
    let x;
    let y;

    if (event.touches && event.touches.length) {
      x = event.touches[0].clientX;
      y = event.touches[0].clientY;
    } else {
      x = event.clientX;
      y = event.clientY;
    }

    this.updateParallax(x, y);
  }

  /**
   * Apply parallax effect based on cursor position
   *
   * @param {Number} x
   * @param {Number} y
   */
  updateParallax(x, y) {
    const percentX = (x - this.centerX) / this.centerX;
    const percentY = (y - this.centerY) / this.centerY;

    this.imageTargets.forEach((image, index) => {
      const depth = +image.dataset.parallaxDepth || 1;
      const moveX = percentX * depth * 30;
      const moveY = percentY * depth * 30;
      this.positions[index].x(moveX);
      this.positions[index].y(moveY);
    });
  }

  /**
   * Disconnect the controller.
   */
  disconnect() {
    this.ctx.revert();
  }
}
